/** @constant {number} */
export const CHEVRON_ICON_SIZE = 16;

/** @constant {number} */
export const FLAG_ICON_SIZE = 12;

/** @constant {number} */
export const FLAG_ICON_SIZE_MOBILE = 24;
